import {
	ConfirmationActions,
	SearchMeditatorActions,
	TableTitles,
} from "@/constants";
import {
	useAcceptRejectRegistrationPendingMeditators,
	useGetRegistrationPendingMeditators,
} from "@/hooks/query-hooks/useMeditators";
import { cn } from "@/libs/cn";
import { Button, Divider, Space, TableProps } from "antd";
import { useState } from "react";
import { PageTitle } from "../common";
import { ManualRegisterMeditator } from "./ManualRegisterMeditator";
import { RegistrantDetailDrawer } from "./RegistrantDetailDrawer";
import { RegistrantTable } from "./RegistrantTable";
import { RejectRegistrantModal } from "./RejectRegistrantModal";

export function PendingNewRegistrants() {
	const [page, setPage] = useState(1);
	const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
	const { data, isLoading } = useGetRegistrationPendingMeditators(page);
	const meditators = data?.content || [];

	const renderColumnsKey = [
		TableTitles.registrant_name,
		TableTitles.retreat_level,
		TableTitles.retreat_name,
		TableTitles.retreat_start_date,
		TableTitles.retreat_end_date,
		TableTitles.total_registrants,
		TableTitles.action,
	];

	const rowSelection: TableProps<MeditatorWithMeditationRetreat>["rowSelection"] =
		{
			type: "checkbox",
			selectedRowKeys,
			onChange: (selectedRowKeys: React.Key[]) => {
				setSelectedRowKeys(selectedRowKeys);
			},
		};

	const { mutate } = useAcceptRejectRegistrationPendingMeditators();

	const handleAcceptReject = (action: ConfirmationActions) => {
		const keyword =
			action === ConfirmationActions.ACCEPT ? "Accept" : "Reject";
		if (selectedRowKeys.length === 0) {
			alert(`Please select at least one registrant to ${keyword}.`);
			return;
		}

		const payload = {
			ids: selectedRowKeys as number[],
			action,
		};

		mutate(payload, {
			onSuccess: () => {
				setSelectedRowKeys([]);
			},
		});
	};

	return (
		<>
			<div className="flex items-center justify-between">
				<PageTitle>စာရင်းသွင်းထားသောယောဂီများ</PageTitle>

				<Space className="flex-1 justify-end relative">
					<Button
						size="large"
						type="link"
						onClick={() =>
							handleAcceptReject(ConfirmationActions.ACCEPT)
						}
						className={cn("!font-poppins duration-300", {
							"opacity-0 pointer-events-none":
								selectedRowKeys.length === 0,
						})}
					>
						Accept
					</Button>
					<Button
						size="large"
						type="text"
						danger
						onClick={() =>
							handleAcceptReject(ConfirmationActions.REJECT)
						}
						className={cn("!font-poppins duration-300", {
							"opacity-0 pointer-events-none":
								selectedRowKeys.length === 0,
						})}
					>
						Reject
					</Button>
					<div
						className={cn("duration-500 absolute top-0 right-0", {
							"-translate-x-[115%]": selectedRowKeys.length > 0,
						})}
					>
						<ManualRegisterMeditator
							modalType={SearchMeditatorActions.REGISTERATION}
						/>
					</div>
				</Space>
			</div>
			<Divider />
			<RegistrantTable
				loading={isLoading}
				dataSource={meditators}
				rowSelection={rowSelection}
				renderColumnKeys={renderColumnsKey}
				TableActionComponent={TableActionComponent}
				rowKey={(record) => record.user.id}
				pagination={{
					current: page,
					pageSize: 10,
					total: data?.totalElements || 0,
					onChange: (page) => setPage(page),
				}}
			/>
		</>
	);
}

const TableActionComponent = ({
	record,
}: {
	record: MeditatorWithMeditationRetreat;
}) => {
	return (
		<>
			<RegistrantDetailDrawer
				registrant={record}
				Component={({ registrant, onToggleDrawer }) => (
					<RejectRegistrantModal
						registrantId={registrant.id}
						onToggleDrawer={onToggleDrawer}
						modalType="registration_pending"
					/>
				)}
				confirmationAction={ConfirmationActions.ACCEPT}
				drawerType={SearchMeditatorActions.REGISTERATION}
			/>
		</>
	);
};
